exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.commande-form .el-input.is-disabled .el-input__inner {\n  color: #000!important;\n}\n", ""]);

// exports
